import { translate } from "src/i18n/tHelper";

export class MesajTipTanimlari {
    id: number = 0;
    label: string = "";
};
const translatePath = "parts|mesaj";
export const mesajTipleriData: Array<MesajTipTanimlari> = [
    {
        id: 1,
        label: translate(translatePath, "Modül")
    },
    {
        id: 2,
        label: translate(translatePath, "Personel")
    },
];